import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';

import type { KnownKinds } from './types';

/**
 * Normalizes an entity reference string.
 *
 * Example: 'name' -> 'kind:namespace/name'
 */
export const normalizeEntityRef = (ref: string, defaultKind?: KnownKinds) =>
  stringifyEntityRef(parseEntityRef(ref, { defaultKind }));
